import angular from 'angular';
import projectDetailsComponent from './project-details.component';
import sharedProjectViewComponent from './views/shared-project-view/shared-project-view.component';
import primeProjectViewComponent from './views/prime-project-view/prime-project-view.component';
import primeCostPlusProjectViewComponent from './views/prime-cost-plus-project-view/prime-cost-plus-project-view.component';
import subcontractProjectViewComponent from './views/subcontract-project-view/subcontract-project-view.component';
import obligationFundingPanelComponent from './views/obligation-funding-panel/obligation-funding-panel.component';
import EmployeeCardList from './components/employee-card-list/employee-card-list';
import { fundingRowDragHandleDirective, fundingRowDropDirective } from './funding-row-drag.directive';
import { Chart } from 'chart.js';

let projectDetailsModule = angular.module('projectDetails', [
  'chart.js',
  EmployeeCardList.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.directive('fundingRowDragHandle', fundingRowDragHandleDirective)
.directive('fundingRowDrop', fundingRowDropDirective)

.component('sharedProjectView', sharedProjectViewComponent)
.component('primeProjectView', primeProjectViewComponent)
.component('primeCostPlusProjectView', primeCostPlusProjectViewComponent)
.component('subcontractProjectView', subcontractProjectViewComponent)
.component('obligationFundingPanel', obligationFundingPanelComponent)
.component('projectDetails', projectDetailsComponent);

Chart.pluginService.register({
  beforeDatasetDraw: function(chart) {
    if (chart.config.options.elements.center) {
      // Get ctx from string
      var ctx = chart.chart.ctx;

      // Get options from the center object in options
      var centerConfig = chart.config.options.elements.center;
      var fontStyle = centerConfig.fontStyle || 'Arial';
      var txt = centerConfig.text;
      var color = centerConfig.color || '#000';
      var maxFontSize = centerConfig.maxFontSize || 75;
      var sidePadding = centerConfig.sidePadding || 20;
      var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
      // Start with a base font of 30px
      ctx.font = "30px " + fontStyle;

      // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      var stringWidth = ctx.measureText(txt).width;
      var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

      // Find out how much the font can grow in width.
      var widthRatio = elementWidth / stringWidth;
      var newFontSize = Math.floor(30 * widthRatio);
      var elementHeight = (chart.innerRadius * 2);

      // Pick a new font size so it will not be larger than the height of label.
      var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
      var minFontSize = centerConfig.minFontSize;
      var lineHeight = centerConfig.lineHeight || 25;
      var wrapText = false;

      if (minFontSize === undefined) {
        minFontSize = 20;
      }

      if (minFontSize && fontSizeToUse < minFontSize) {
        fontSizeToUse = minFontSize;
        wrapText = true;
      }

      // Set font settings to draw it correctly.
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
      var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
      ctx.font = fontSizeToUse + "px " + fontStyle;
      ctx.fillStyle = color;

      if (!wrapText) {
        ctx.fillText(txt, centerX, centerY);
        return;
      }

      var words = txt.split(' ');
      var line = '';
      var lines = [];

      // Break words up into multiple lines if necessary
      for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' ';
        var metrics = ctx.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > elementWidth && n > 0) {
          lines.push(line);
          line = words[n] + ' ';
        } else {
          line = testLine;
        }
      }

      // Move the center up depending on line height and number of lines
      centerY -= (lines.length / 2) * lineHeight;

      for (var n = 0; n < lines.length; n++) {
        ctx.fillText(lines[n], centerX, centerY);
        centerY += lineHeight;
      }
      //Draw text in center
      ctx.fillText(line, centerX, centerY);
    }
  }
});

export default projectDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/project-details.js